import React, { useState, useEffect } from "react";
import "./styles.css";
import Header from "../../components/Header/Header";
import BottomNav from "../../components/BottomNav/BottomNav";
import { ChevronRight, icons, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import promoBanner from "../../images/menuImage.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

export default function Menu({ sociallink, featuredGames = [], promotions }) {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const isLoggedIn = !!localStorage.getItem("token");
  const [visibleGames, setVisibleGames] = useState(6);
  const [expandedMenu, setExpandedMenu] = useState("");
  const [showLiveChat, setShowLiveChat] = useState(true);
  const [systems, setSystems] = useState([]);
  const [providers, setProviders] = useState([]);
  const [error, setError] = useState(null);
  const [isBlurring, setIsBlurring] = useState(false);
  const [isContentReady, setIsContentReady] = useState(false);
  const [animationDirection, setAnimationDirection] = useState('down');
  
  const CATEGORY_MAP = {
    hot: "HOT",
    sports: "SPORTS",
    slots: "SLOT",
    table: "TABLE",
    crash: "EGAME",
    fishing: "FH",
    lottery: "LOTTO",
  };

  const menuItems = [
    {
      id: "hot",
      label: "Favorites",
      icon: "/images/menu/sidemenu icon.svg",
    },
    {
      id: "hot",
      label: "Exclusive",
      icon: "/images/animation/exchange.png",
    },
    {
      id: "sports",
      label: "Sports",
      icon: "/images/menu/sidemenu collapse icon-1.svg",
    },
    {
      id: "slots",
      label: "Slots",
      icon: "/images/animation/slot.png",
    },
    {
      id: "crash",
      label: "Crash",
      icon: "/images/animation/crash.png",
    },
    {
      id: "table",
      label: "Table",
      icon: "/images/animation/table.png",
    },
    {
      id: "fishing",
      label: "Fishing",
      icon: "/images/animation/fish.png",
    },
    {
      id: "arcade",
      label: "Arcade",
      icon: "/images/animation/arcade.png",
    },
    {
      id: "lottery",
      label: "Lottery",
      icon: "/images/animation/lottery.png",
    },
    {
      id: "promotions",
      icon: "https://img.b112j.com/bj/h5/assets/v3/images/icon-set/utility-type/icon-gift.svg?v=1770792598866",
      label: "Promotions",
      badge: "VIEW ALL",
      route: false,
      expandable: true,
    },
  ];

  const isMobile =
    typeof window !== "undefined"
      ? window.innerWidth <= 768 ||
      /Mobi|Android/i.test(window.navigator.userAgent)
      : false;

  const bottomMenuItems = [
    {
      id: "contact",
      icon: "https://img.b112j.com/bj/h5/assets/v3/images/icon-set/utility-type/icon-phone.svg?v=1770792598866",
      label: "Contact Us",
      expandable: true,
      route: false,
      children: [
        { label: "Whatsapp", linked: sociallink?.whatsapp, external: true, icon: "https://img.b112j.com/upload/customerservice/image_2010.png" },
        { label: "Email", linked: sociallink?.telegram, external: true, icon: "https://img.b112j.com/upload/customerservice/image_86.png" },
        { label: "Facebook", linked: sociallink?.facebook, external: true, icon: "https://img.b112j.com/upload/customerservice/image_2002.png" },
      ],
    },
    {
      id: "vip-club",
      icon: "https://img.b112j.com/bj/h5/assets/v3/images/icon-set/utility-type/icon-crown.svg?v=1770792598866",
      label: "VIP Club",
      route: true,
    },
    {
      id: "referral",
      icon: "https://img.b112j.com/bj/h5/assets/v3/images/icon-set/utility-type/icon-referral.svg?v=1770792598866",
      label: "Referral program",
      route: true,
    },
    {
      id: "promotions",
      icon: "https://img.b112j.com/bj/h5/assets/v3/images/icon-set/utility-type/icon-affiliate.svg?v=1770792598866",
      label: "Affiliate",
      route: true,
    },
    {
      id: "brandAmbassador-detail",
      icon: "https://img.b112j.com/bj/h5/assets/v3/images/icon-set/utility-type/icon-ambassador.svg?v=1770792598866",
      label: "Brand Ambassadors",
      route: true,
    },
    {
      id: "download",
      icon: "https://img.b112j.com/bj/h5/assets/v3/images/icon-set/utility-type/icon-download.svg?v=1770792598866",
      label: "APP Download",
      route: true,
    },
    {
      label: "About Baji",
      icon: "https://img.b112j.com/bj/h5/assets/v3/images/icon-set/utility-type/icon-person-info.svg?v=1770792598866",
      external: true, linker: "https://img.b112j.com/bj/h5/assets/v3/images/icon-set/utility-type/icon-open-in-new.svg?v=1770792598866"
    },
    {
      label: "New Member Guide",
      icon: "https://img.b112j.com/bj/h5/assets/v3/images/icon-set/utility-type/icon-open-book.svg?v=1770792598866",
      external: true, linker: "https://img.b112j.com/bj/h5/assets/v3/images/icon-set/utility-type/icon-open-in-new.svg?v=1770792598866"
    },
    {
      label: "BJ Forum",
      icon: "https://img.b112j.com/bj/h5/assets/v3/images/icon-set/utility-type/icon-chat-bubble.svg?v=1770792598866",
      external: true, linker: "https://img.b112j.com/bj/h5/assets/v3/images/icon-set/utility-type/icon-open-in-new.svg?v=1770792598866"
    },
  ];

  const handleLoadMore = () => {
    setVisibleGames((prev) => prev + 6);
  };

  const sportsSubmenu = [
    { label: "9wickets", icon: "9wickets.png", link: "/exchange" },
    { label: "Velki", icon: "velki.png", link: "/velki" },
    {
      label: "SABA",
      icon: "saba.png",
      code: "08ced9dd788aed11ff3c7f387ae0f063",
      type: "Sports Game",
      platform: "SABASports(IBC)",
    },
  ];

  const toggleMenu = (id) => {
    const isOpening = expandedMenu !== id;
    
    if (isOpening) {
      // Opening - SLOWER (2x slower than original)
      setAnimationDirection('down');
      setIsBlurring(true);
      
      setTimeout(() => {
        setIsContentReady(false);
      }, 200);  // was 100ms
      
      setTimeout(() => {
        setExpandedMenu(id);
        setIsBlurring(false);
        setIsContentReady(true);
      }, 500);  // was 250ms
    } else {
      // Closing - SLOWER (2x slower than original)
      setIsContentReady(false);
      setTimeout(() => {
        setExpandedMenu("");
        setIsBlurring(false);
      }, 300);  // was 150ms
    }
    
    setSystems([]);
    setProviders([]);
    setVisibleGames(6);
  };

  useEffect(() => {
    if (!expandedMenu || !CATEGORY_MAP[expandedMenu]) return;
    if (CATEGORY_MAP[expandedMenu] === "HOT") return;
    if (CATEGORY_MAP[expandedMenu] === "SPORTS") return;

    const fetchData = async () => {
      const type = CATEGORY_MAP[expandedMenu];

      const resSys = await fetch(
        `${process.env.REACT_APP_API_URL}/api/get-system?type=${type}`,
      );
      const dataSys = await resSys.json();
      const systems = dataSys.systems || [];
      setSystems(systems);

      if (!systems.length) {
        setProviders([]);
        return;
      }

      const resProv = await fetch(
        `${process.env.REACT_APP_API_URL}/api/get-provider?system=${encodeURIComponent(
          JSON.stringify(systems),
        )}`,
      );
      const dataProv = await resProv.json();
      setProviders(dataProv.data || []);
    };

    fetchData();
  }, [expandedMenu]);

  const handleProviderClick = (platform, type, title) => {
    navigate(
      `/casino?type=${type}&system=${platform}&title=${encodeURIComponent(
        title,
      )}`,
    );
  };

  const handleShowModal = async (promotionId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/promotions/${promotionId}`,
      );
      if (!response.ok) {
        throw new Error("Failed to fetch promotion details");
      }
      const promotionDetails = await response.json();
      navigate("/promotions-detail", {
        state: { promotion: promotionDetails },
      });
    } catch (error) {
      console.error("Error fetching promotion details:", error);
    } finally {
    }
  };

  const handleGameClick = async (gameCode, gamePlatform, gameType) => {
    if (!isLoggedIn) {
      navigate("/login");
      return;
    }

    const token = localStorage.getItem("token");
    const remote_id = localStorage.getItem("remote_id");

    if (!token || !remote_id) {
      setError("User not logged in");
      return;
    }

    setIsLoading(true);

    try {
      if (typeof gameCode === "string" && /^https?:\/\//i.test(gameCode)) {
        navigate("/gamerun", { state: { iframeUrl: gameCode } });
        return;
      }

      if (
        (!gamePlatform || !gameType) &&
        typeof gameCode === "string" &&
        gameCode.includes("-")
      ) {
        const parts = gameCode.split("-");
        if (parts.length >= 2) {
          gamePlatform = parts[0];
          gameType = parts[1];
        }
      }
      if (gamePlatform === "Lucky" || gamePlatform === "LuckySpodddrt") {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/player-login`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ user_id: remote_id }),
          },
        );

        const dataly = await response.json();
        if (dataly?.access_token) {
          navigate("/gamerun", {
            state: {
              iframeUrl: `https://sprodm.uni247.xyz/?access_token=${dataly.access_token}`,
            },
          });
          return;
        }
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/inr-game-run`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            userId: remote_id,
            externalURL: origin,
            isMobileLogin: isMobile,
            gameCode: gameCode,
            gameType: gameType,
            platform: gamePlatform,
          }),
        },
      );

      const data = await response.json();

      if (response.ok) {
        const iframeUrl = data?.url || data?.data?.payload?.game_launch_url;
        if (iframeUrl) {
          navigate("/gamerun", { state: { iframeUrl } });
        } else {
          setError(data.message || "An unexpected error occurred");
        }
      } else {
        setError(data.message || "An unexpected error occurred");
      }
    } catch (error) {
      console.error("Error launching game:", error);
      setError("An unexpected error occurred");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <aside className="sidebar">
      <Header />

      {/* Live Chat */}
      {showLiveChat && (
        <div className="live-chat-banner">
          <div className="live-chat-content">
            💬 <span>24/7 Live Chat</span>
          </div>
          <button className="close-button" onClick={() => navigate(-1)}>
            <X size={18} />
          </button>
        </div>
      )}

      {/* Top Promo Banner */}
      <div className="promo-banner-rep">
        <img src={promoBanner} alt="Promo Banner" />
      </div>

      {/* Menu Section */}
      <div 
        className="menu-section"
        style={{
          filter: isBlurring ? 'blur(8px)' : 'blur(0px)',
          transition: 'filter 0.5s ease-in-out'  // SLOWER - was 0.25s
        }}
      >
        {menuItems.map((item) => (
          <div key={item.id}>
            <div
              className={`menu-item ${expandedMenu === item.id ? "active" : ""}`}
              onClick={() => {
                if (CATEGORY_MAP[item.id] || item.expandable) {
                  toggleMenu(item.id);
                } else if (item.route) {
                  navigate("/" + item.id);
                }
              }}
            >
              <div className="menu-item-left">
                <span>
                  {" "}
                  <img src={item.icon} width={21} alt={item.icon} />
                </span>
                <span>{item.label}</span>
              </div>
              {item.badge && (
                <span className="menu-item-badge">{item.badge}</span>
              )}
              <ChevronRight
                className={`chevron-icon ${expandedMenu === item.id ? "rotated" : ""}`}
              />
            </div>
            
            {/* ================= HOT / EXCLUSIVE ================= */}
            {item.id === "hot" && expandedMenu === "hot" && (
              <div
                style={{
                  opacity: isContentReady ? 1 : 0,
                  transform: isContentReady ? 'translateY(0)' : 'translateY(-20px)',
                  transition: 'all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)'  // SLOWER - was 0.4s
                }}
              >
                <div className="games-grid-cass">
                  {featuredGames.slice(0, visibleGames).map((game, index) => (
                    <div
                      key={index}
                      className="game-card"
                      onClick={() => handleGameClick(game)}
                      style={{
                        animation: isContentReady ? `menuSlideDown 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) ${index * 0.08}s forwards` : 'none',  // SLOWER - was 0.5s and 0.05s
                        opacity: 0
                      }}
                    >
                      <img
                        src={`${process.env.REACT_APP_API_URL}/storage/${game.thubmnail}`}
                        alt={game.name}
                      />
                    </div>
                  ))}
                </div>

                {visibleGames < featuredGames.length && (
                  <div style={{ textAlign: "center", marginTop: 12 }}>
                    <button
                      className="load-more-btn"
                      onClick={handleLoadMore}
                    >
                      Load more
                    </button>
                  </div>
                )}
              </div>
            )}

            {/* SPORTS SUBMENU */}
            {item.id === "sports" && expandedMenu === "sports" && (
              <div 
                className="submenu-grid"
                style={{
                  opacity: isContentReady ? 1 : 0,
                  transform: isContentReady ? 'translateY(0)' : 'translateY(-20px)',
                  transition: 'all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)'  // SLOWER
                }}
              >
                {sportsSubmenu.map((s, i) => (
                  <div 
                    key={i} 
                    className="submenu-item"
                    style={{
                      animation: isContentReady ? `menuSlideDown 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) ${i * 0.08}s forwards` : 'none',  // SLOWER
                      opacity: 0
                    }}
                  >
                    <div
                      className="submenu-icon tab-icon"
                      style={{ background: s.bg }}
                    >
                      <img
                        src={`${process.env.REACT_APP_API_URL}/icon/${s.icon}`}
                        alt={s.name}
                      />
                    </div>
                    <span className="submenu-text">{s.label}</span>
                  </div>
                ))}
              </div>
            )}
            
            {item.id === "promotions" && expandedMenu === "promotions" && (
              <div
                style={{
                  opacity: isContentReady ? 1 : 0,
                  transform: isContentReady ? 'translateY(0)' : 'translateY(-20px)',
                  transition: 'all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)'  // SLOWER
                }}
              >
                <Swiper
                  slidesPerView={1.5}
                  spaceBetween={2}
                  grabCursor={true}
                >
                  {promotions.map((pro) => (
                    <SwiperSlide key={pro.id}>
                      <div
                        className="promo-banner-rep"
                        onClick={() => handleShowModal(pro.id)}
                      >
                        <img
                          src={`${process.env.REACT_APP_API_URL}/storage/${pro.thumbnail}`}
                          alt={pro.name}
                          loading="lazy"
                        />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            )}

            {/* PROVIDERS GRID FOR SLOT / CASINO / ETC */}
            {CATEGORY_MAP[item.id] &&
              expandedMenu === item.id &&
              providers.length > 0 && (
                <div 
                  className="submenu-grid"
                  style={{
                    opacity: isContentReady ? 1 : 0,
                    transform: isContentReady ? 'translateY(0)' : 'translateY(-20px)',
                    transition: 'all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)'  // SLOWER
                  }}
                >
                  {providers.map((provider, index) => (
                    <div
                      key={index}
                      className="submenu-item"
                      onClick={() =>
                        handleProviderClick(
                          provider.platform,
                          CATEGORY_MAP[item.id],
                          item.label,
                        )
                      }
                      style={{
                        animation: isContentReady ? `menuSlideDown 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) ${index * 0.08}s forwards` : 'none',  // SLOWER
                        opacity: 0
                      }}
                    >
                      <img
                        src={`${process.env.REACT_APP_API_URL}/provider/${provider.platform}.png`}
                        alt={provider.platform}
                        style={{ width: 28, height: 28, marginRight: 16 }}
                      />
                      <span style={{ color: "#fff", fontSize: 14 }}>
                        {provider.platform
                          .replace("icon-", "")
                          .replace("-", " ")}
                      </span>
                    </div>
                  ))}
                </div>
              )}
          </div>
        ))}
      </div>

      {/* Bottom Menu */}
      <div 
        className="menu-section bottom-menu" 
        style={{ 
          marginBottom: 90,
          filter: isBlurring ? 'blur(8px)' : 'blur(0px)',
          transition: 'filter 0.5s ease-in-out'  // SLOWER
        }}
      >
        {bottomMenuItems.map((item) => {
          if (!isLoggedIn && item.id === "vip-club") return null;
          if (!isLoggedIn && item.id === "referral") return null;
          if (!isLoggedIn && item.id === "promotions") return null;

          return (
            <div key={item.id}>
              <div
                className="menu-item"
                onClick={() => {
                  if (item.expandable) toggleMenu(item.id);
                  else if (item.route) navigate("/" + item.id);
                }}
              >
                <div className="menu-item-left">
                  <span>
                    <img src={item.icon} alt={item.icon} />
                  </span>
                  <span>{item.label}</span>
                </div>

                {item.expandable ? (
                  <ChevronRight
                    className={`chevron-icon ${expandedMenu === item.id ? "rotated" : ""
                      }`}
                  />
                ) : (
                  <>
                    {item.linker ? (
                      <img width={21} src={item.linker} />
                    ) : (
                      <ChevronRight size={16} />
                    )}
                  </>
                )}
              </div>

              {/* CONTACT US SUBMENU */}
              {item.expandable && expandedMenu === item.id && (
                <div 
                  className="contact-submenu"
                  style={{
                    opacity: isContentReady ? 1 : 0,
                    transform: isContentReady ? 'translateY(0)' : 'translateY(-20px)',
                    transition: 'all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)'  // SLOWER
                  }}
                >
                  {item.children.map((child, i) => (
                    <a
                      key={i}
                      href={child?.linked}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contact-itemss"
                      style={{
                        animation: isContentReady ? `menuSlideDown 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) ${i * 0.08}s forwards` : 'none',  // SLOWER
                        opacity: 0
                      }}
                    >
                      <img
                        src={child?.icon}
                        alt={child?.label || "icon"}
                        width={21}
                      />
                      <span>{child?.label}</span>
                    </a>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>

      <BottomNav />

      <style jsx>{`
        @keyframes menuSlideDown {
          0% {
            opacity: 0;
            transform: translateY(-30px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </aside>
  );
}